// Angular dependencies.
import { Injectable } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';
import { Action } from '@ngrx/store';

// Rxjs dependencies
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/ignoreElements';
import { Observable } from 'rxjs/Observable';
import { UPDATE_LINK } from './app.actions';
import { ADD_CREEP, UPDATE_CREEP, REMOVE_CREEP } from './creeps.actions';

// Store
import { Store } from '@ngrx/store';
import { AppState } from './app.reducer';

import { Creep } from '../creep';

@Injectable()
export class CreepsEffects {
  @Effect()
  addCreep$: Observable<Action> = this.actions$
    .ofType(ADD_CREEP)
    .do(() => this._store.dispatch({ type: UPDATE_LINK }))
    .ignoreElements();

  @Effect()
  updateCreep$: Observable<Action> = this.actions$
    .ofType(UPDATE_CREEP)
    .do(() => this._store.dispatch({ type: UPDATE_LINK }))
    .ignoreElements();

  @Effect()
  removeCreep$: Observable<Action> = this.actions$
    .ofType(REMOVE_CREEP)
    .do(() => this._store.dispatch({ type: UPDATE_LINK }))
    .ignoreElements();

    constructor(
      private actions$: Actions,
      private _store: Store<AppState>
    ) { }
}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/store.module/creeps.effects.ts